import { Box, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { Paper, SignatureFieldHandle, StepsContainer, VerticalBarLoader } from '@roc/ui';
import { observer } from 'mobx-react';
import { ThankYouVerifyBankInfo } from './thankYouVerifyBankInfo';
import { VendorBankInformationVerificationForm } from './vendorBankInformationVerificationForm';
import { VendorBankInformationSignature } from './vendorBankInformationSignature';
import { useRef } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useExternalAgentLoansStore } from 'libs/feature-title-agent/src/hooks/useExternalAgentLoansStore';


const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(3, 0, 4),
    borderRadius: theme.spacing(2),
  },
  stepper: {
    maxWidth: 800,
    margin: 'auto',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  },
}));

export const VendorBankInformationVerification = observer(() => {
  const { vendorCompanyProfileStore } = useExternalAgentLoansStore();
  const { vendorBankInformationStore } = vendorCompanyProfileStore;
  const { globalStore } = useStore();
  const classes = useStyles();
  const { activeStep } = vendorBankInformationStore;
  const signatureRef = useRef<SignatureFieldHandle>(null);
  const { userStore } = useStore();
  const companyId = userStore.userInformation.companyId
  const steps = [
    {
      title: 'Verify Bank Information Form',
      icon: null,
      onBack: () => {
        vendorBankInformationStore.goPrevStep();
      },
      onNext: async () => {
        if (vendorBankInformationStore.bankInformationFormStore.form.meta.isValid) {
          vendorBankInformationStore.goNextStep();
        } else {
          vendorBankInformationStore.bankInformationFormStore.runFormValidationWithMessage();
        }
      },
      allowBack: false,
      allowNext: true,
    },
    {
      title: `${'Signature'}`,
      icon: null,
      onBack: () => {
        vendorBankInformationStore.goPrevStep();
      },
      onNext: async () => {
        generateDocument();
      },
      nextButtonText: "SUBMIT",
      allowBack: true, //finished ? false : true,
      allowNext: true,
    },
    {
      title: `${'Thank you'}`,
      icon: null,
      allowBack: false,
      allowNext: true,
    },
  ];

  const generateDocument = async () => {
    if (signatureRef.current.isSigned()) {
      const signatureURL = signatureRef.current.getSignature();
      await vendorBankInformationStore.generateDocument(signatureURL);
      vendorCompanyProfileStore.getCompanyInformation(companyId);
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please sign the document before submitting it',
      });
    }
  }

  const getStepsContent = () => {
    const stepsContent = [];
    stepsContent.push(<VendorBankInformationVerificationForm />)
    stepsContent.push(<VendorBankInformationSignature signatureRef={signatureRef} />);
    stepsContent.push(<ThankYouVerifyBankInfo />);
    return stepsContent;
  };

  return (
    <Layout maxWidth={'lg'}>
      {(
        <>
          <Box my={3}>
            <Typography variant="h3" gutterBottom>
              {'Please fill the bank information form'}
            </Typography>
          </Box>

          <Paper className={classes.paper}>
            <StepsContainer
              activeStep={activeStep}
              disableNavigation={true}
              steps={steps}
              stepperClassName={classes.stepper}
            >
              {getStepsContent()}
            </StepsContainer>
          </Paper>
        </>
      )}
      {vendorBankInformationStore.loading && <VerticalBarLoader />}
    </Layout>
  );
});
